import { createResourceCollection } from '@/request'
import { UtilityPlanRateIntervals } from '@/types/utilityPlanRateInterval'

export const utilityPlanRateIntervalsCollection =
  createResourceCollection<UtilityPlanRateIntervals>({
    name: 'utilityPlanRateIntervalsCollection',
    selector: (state) => state.utilityPlanRateIntervalsCollection,
    apiConfig: {
      path: 'utility_plan_rate_intervals',
    },
  })

export default utilityPlanRateIntervalsCollection.slice.reducer
